export default {
  steps: {
    setup_fee: 'Käyttöönottomaksu',
    business_info: 'Yrityksen tiedot',
    create_preview: 'Luo esikatselusopimus',
    preview: 'Esikatsele sopimus',
    sign: 'Allekirjoita sopimus',
  },
  buttons: {
    next: 'Esikatsele sopimus',
    save_and_continue: 'Tallenna ja jatka',
    update: 'Päivitä esikatselu',
    cancel: 'Peruuta nykyinen',
    skip: 'Ohita sopimuksen luonti',
  },
  create_preview: {
    header: 'Luo esikatselusopimus',
    description: 'Syötä sopimuksen vastaanottajan tiedot. Voit vielä muuttaa niitä ennen lähettämistä.',
  },
  sign: {
    update_notice: 'Päivittääksesi sopimuksen peruuta nykyinen ja muokkaa tietoja.',
  },
  toasts: {
    failed_to_save_changes: 'Muutosten tallentaminen epäonnistui',
  },
};
